let animated = false
async function animateValue(obj, start, end, duration, originalText) {
	let startTimestamp = null
	const step = timestamp => {
		if (!startTimestamp) startTimestamp = timestamp
		const progress = Math.min((timestamp - startTimestamp) / duration, 1)
		let animatedNumber = Math.floor(progress * (end - start) + start);
		if(isNaN(animatedNumber)) {
			obj.innerHTML = originalText;
		} else {
			obj.innerHTML = animatedNumber
		}
		
		if (progress < 1) {
			window.requestAnimationFrame(step)
		} else {
			obj.innerHTML = originalText
		}
	}
	window.requestAnimationFrame(step)
}

window.addEventListener('scroll', function() {
	var elementTarget = document.getElementsByClassName('icons-numbers')
	var allInstances = [].slice.call(elementTarget)

	function isInView(el) {
		const box = el.getBoundingClientRect()
		return box.top < window.innerHeight && box.bottom >= 0
	}
	allInstances.forEach(ele => {
		if (isInView(ele) && !animated) {
			const obj = document.getElementsByClassName('value')
			var arr = [].slice.call(obj)

			arr.forEach(async o => {
				if (o.innerHTML !== '') {
					let text = o.innerHTML
					await animateValue(
						o,
						0,
						Number(o.innerHTML.replace(/[.,%\s]/g, '')),
						1000,
						text
					)
				}
			})

			animated = true
		}
	})
})
